import { useState } from 'react';
import { Header } from '../../styles';
import { ContentWrapper, LinkLabel, ReadMoreParagraph, StyledSection } from './styles';

const DescriptionComponent = ({ description }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const paragraphStyles = {
    height: isCollapsed ? undefined : 'auto',
  };

  const toggleReadMore = () => setIsCollapsed((current) => !current);

  return (
    <StyledSection>
      <Header>Description:</Header>
      <ContentWrapper>
        <ReadMoreParagraph style={paragraphStyles}>{description}</ReadMoreParagraph>
        <LinkLabel
          href='#'
          onClick={toggleReadMore}>
          {isCollapsed ? 'Read more...' : 'Read less'}
        </LinkLabel>
      </ContentWrapper>
    </StyledSection>
  );
};

export default DescriptionComponent;
